import '.ci{font-size:1.125rem;}.ssr-plugin'
import '.g8{line-height:1.75rem;}.ssr-plugin'
import '.bj{text-decoration:none;}.ssr-plugin'
import '.dv{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="ci g8"
    >
      {translations.privacySubtitle}{' '}
      <a className="bj dv"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="bj dv"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
